import type {Expand} from '../../types';

export const foodShareExpandCommon: Expand = {
  food_share: [['user_id', null, {user: ['avatar_id']}], 'attachment_ids'],
};
